import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ViewTrailerDetailsByLocation from './cards-panel/ViewTrailerDetailsByLocation';
import ViewLocationDetailsByTrailer from './cards-panel/ViewLocationDetailsByTrailer';
import ViewSummaryByTrailer from './sidebar/ViewSummaryByTrailer';
import ViewSummaryByLocation from './sidebar/ViewSummaryByLocation';
import { usePrefetch } from '../../dispatchingApi';

const TrailerStatus = () => {
  const { viewBy } = useParams();

  const prefetchTrailerSummary = usePrefetch('viewTrailerSummaryByTrailer');

  // prettier-ignore
  const sidebar = viewBy === 'trailer'
    ? <ViewSummaryByTrailer/> 
    : <ViewSummaryByLocation />;
  // prettier-ignore
  const cardsPanel = viewBy === 'trailer' 
    ? <ViewLocationDetailsByTrailer /> 
    : <ViewTrailerDetailsByLocation />;

  useEffect(() => {
    prefetchTrailerSummary();
  }, [prefetchTrailerSummary]);

  return (
    <>
      {sidebar}
      {cardsPanel}
    </>
  );
};

export default TrailerStatus;
